import { TextColumn } from "@portal/BaseComponents/Table/Components/Text/TextColumn";
import { AppPageParams } from "@portal/lib/router/constants/page-info";
import { usePageNavigate } from "@portal/lib/router/hooks/usePageNavigae";
import { DisputeList } from "@portal/types/entities/dispute";
import { CellRenderProps } from "@sinecycle/growcomponents";
import { useParams } from "react-router-dom";

function DisputeTitle(props: CellRenderProps<DisputeList>) {
  const { data } = props;
  const navigate = usePageNavigate();
  const { customer_id } = useParams<AppPageParams>();
  if (!data) return;
  return (
    <TextColumn
      text={data.title}
      type="Text"
      textProps={{
        style: {
          textAlign: "left",
          cursor: "pointer",
          color: "var(--primary-7)",
        },
        ellipsis: { tooltip: data.title },
        onClick() {
          if (!customer_id) return;
          navigate({
            appPage: "DISPUTE_DETAILS",
            pathParams: {
              customer_id,
              dispute_id: data.id,
            },
          });
        },
      }}
    />
  );
}

export { DisputeTitle };
